import { createContext, type ReactNode, useContext, useEffect, useState } from "react";
import {
  isKioskLanguage,
  LANGUAGE_STORAGE_KEY,
  type KioskLanguage,
} from "@/lib/i18n";

interface LanguageContextValue {
  language: KioskLanguage;
  setLanguage: (language: KioskLanguage) => void;
}

const LanguageContext = createContext<LanguageContextValue | null>(null);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguage] = useState<KioskLanguage>(() => {
    const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return isKioskLanguage(storedLanguage) ? storedLanguage : "gl";
  });

  useEffect(() => {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    document.documentElement.lang = language;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextValue => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
};
